const AutoSummaryRenderer = ({
  question,
  summaryData = {},
  value = {},
  onChange,
  isEditable = true
}) => {

  const schema = question.ui_schema || {};

  const rows = schema.rows || [];

  return (
    <div className="ecf-auto-summary">

      
      <table className="ecf-summary-table">

        <thead>
          <tr>
            <th className="ecf-param-col">
              Parameter
            </th>

            <th className="ecf-value-col">
              Current FY
            </th>
          </tr>
        </thead>

        <tbody>

         {rows.map((row, index) => {

  const isEditableRow =
    row.editable === true;

  // SECTION HEADER ROW
  if (row.type === "section") {

    return (
      <tr
        key={`section-${index}`}
        className="ecf-section-row"
      >
        <td colSpan="2">
        <div className="waste_tagline">{row.label}</div>
          <strong>Category of waste</strong>
        </td>
        
      </tr>
    );

  }

  // TEXTAREA ROW
  if (row.type === "textarea") {

    return (
      <tr key={row.field_key || index}>
        <td>{row.label}</td>

        <td>
          <textarea
            className="ecf-input"
            rows={4}
            placeholder={row.placeholder || ""}
            value={
              value?.[row.field_key] || ""
            }
            disabled={!isEditable}
            onChange={(e) =>
              onChange(
                question.question_code,
                {
                  ...value,
                  [row.field_key]:
                    e.target.value
                }
              )
            }
          />
        </td>
      </tr>
    );

  }

  return (
    <tr
      key={
        row.source_key ||
        row.field_key ||
        index
      }
      className={
        row.highlight
          ? "ecf-highlight-row"
          : ""
      }
    >
      <td>{row.label}</td>

      <td>

        {!isEditableRow ? (

          <>
            {Number(
              summaryData?.[
                row.source_key
              ] || 0
            ).toFixed(2)}

            {row.unit
              ? ` ${row.unit}`
              : ""}
          </>

        ) : (

          <input
            type="text"
            className="ecf-input"
            value={
              value?.[
                row.field_key
              ] || ""
            }
            disabled={!isEditable}
            onChange={(e) =>
              onChange(
                question.question_code,
                {
                  ...value,
                  [row.field_key]:
                    e.target.value
                }
              )
            }
          />

        )}

      </td>
    </tr>
  );

})}

        </tbody>

      </table>
{schema.subtitle && (
        <div className="ecf-sync-badge status auto-badge">
          {schema.subtitle}
        </div>
      )}

    </div>
  );

};

export default AutoSummaryRenderer;